import React, { useState } from 'react';
import Button from '@atlaskit/button';
import type { LayoutType } from '@atlassian/jira-dashboard-common/src/types.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { JiraPopup as Popup } from '@atlassian/jira-popup/src/ui/jira-popup.tsx';
import { LayoutPicker } from './layout-picker/index.tsx';
import messages from './messages.tsx';

export type ChangeLayoutButtonProps = {
	layout: LayoutType;
	onLayoutSelected: (arg1: LayoutType) => void;
};

export const ChangeLayoutButton = ({ layout, onLayoutSelected }: ChangeLayoutButtonProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const { formatMessage } = useIntl();

	return (
		<Popup
			isOpen={isOpen}
			onClose={() => setIsOpen(false)}
			content={() => <LayoutPicker onLayoutSelected={onLayoutSelected} activeLayout={layout} />}
			messageId="dashboard-edit.ui.header-editable.change-layout-button.popup"
			messageType="transactional"
			trigger={(triggerProps) => (
				<Button
					testId="dashboard-edit.ui.header-editable.change-layout-button.layout-picker"
					{...triggerProps}
					onClick={() => setIsOpen(!isOpen)}
					isSelected={isOpen}
				>
					{formatMessage(messages.title)}
				</Button>
			)}
			placement="bottom-end"
		/>
	);
};
